<template>
  <div id="tem">
    <block :nobody="true" ref="btem" class="soft-control">
      <control-panel
        :disabled="{
          edit: true,
          print: false
        }"
        :showPrint="true"
        :showEdit="false"
        :showOption="false"
        :countChecked="countChecked"
        @doAddNew="handleCreate"
        @print="handlePrint"
        @printAll="handlePrintAll"
        @search="handleSearch"
        @copy="handleCopy"
        :help="handleHelp"
        @doDelete="handleDelete"
      >
        <template slot="control">
          <b-col>
            <b-button class="mb-2" block variant="secondary" @click="doBack">
              Trở về
            </b-button>
          </b-col>
        </template>
      </control-panel>
      <div class="row p-1">
        <div class="col-md-12">
          <soft-table
            @rowSelected="tbSetRowSelected"
            @rowClicked="tbRowClicked"
            class="table align-items-center table-flush"
            tbody-classes="list"
            :pending="false"
            :dataTable="temDetails"
            :fields="fields"
            :showAll="true"
            :minHeight="$hControl"
            ref="soft-table"
          >
            <template v-slot:cell(userCreate)="{ value }">
              <span v-if="value.id" class="badge badge-primary">{{
                value.username
              }}</span>
            </template>
            <template v-slot:cell(type)="{ value, item }">
              <template v-if="item.isOdd">
                <span class="badge badge-info" v-if="value == 'BAG'">
                  Tem Bịch
                </span>
                <span class="badge badge-primary" v-else-if="value == 'SACK'">
                  Tem Bao
                </span>
                <span class="badge badge-primary" v-else-if="value == 'ORDER'">
                  Tem Lưu Đơn Hàng
                </span>
                <span class="badge badge-warning" v-else-if="value == 'CORE'">
                  Tem Lõi
                </span>
                - <span>Tem Lẽ</span>
              </template>
              <template v-else>
                <span class="badge badge-info" v-if="value == 'BAG'">
                  Tem Bịch
                </span>
                <span class="badge badge-primary" v-else-if="value == 'SACK'">
                  Tem Bao
                </span>
                <span class="badge badge-primary" v-else-if="value == 'ORDER'">
                  Tem Lưu Đơn Hàng
                </span>
                <span class="badge badge-warning" v-else>Tem Lõi</span>
                <span v-if="item.isCS"> - Tùy chỉnh</span>
              </template>
            </template>
            <template v-slot:cell(code)="{ item }">
              <strike v-if="!item.active">{{ item.code }}</strike>
              <span v-else>{{ item.code }}</span>
            </template>
            <template v-slot:cell(review)="row">
              <b-button @click="row.toggleDetails" variant="link">
                Xem Tem
              </b-button>
            </template>
            <template v-slot:row-details="row">
              <div v-if="row.item.type == 'BAG'">
                  <TemBichPreview
                    :Tem="Tem"
                    :temInfo="row.item"
                    :isEditNote="true"
                    :code="Tem.code"
                    :manufacture="manufacture"
                    style="width:300px"
                  ></TemBichPreview>
              </div>
              <div v-else-if="row.item.type == 'SACK'">
                <TemBaoPreview
                  class="break-auto"
                  :Tem="Tem"
                  :temDetail="row.item"
                  :code="Tem.code"
                  :manufacture="manufacture"
                  :isEditNote="true"
                  style="width:350px; border:1px dotted;"
                ></TemBaoPreview>
              </div>
              <TemDH
                class="break-auto"
                v-else-if="row.item.type == 'ORDER'"
                :Tem="Tem"
                :info="row.item"
                :code="Tem.code"
                :isOdd="row.item.isOdd"
                :manufacture="manufacture"
                style="width:350px; border:1px dotted;"
              ></TemDH>
            </template>
            <template v-slot:cell(status)="{ value }">
              <select disabled :value="value">
                <option value="0">Tem mới</option>
                <option value="1">Đã in</option>
                <option value="2">Đã nhập kho</option>
                <option value="3">Đã xuất kho</option>
              </select>
            </template>
            <template v-slot:cell(lastDatePrint)="{ value }">
              <span v-if="value && value != ''">{{ $dateTime(value) }}</span>
              <span v-else class="badge badge-primary">Chưa in lần nào</span>
            </template>
            <template v-slot:cell(print)="row">
              <template v-if="row.item.active">
                <b-button
                  @click="doPrintTem([row.item])"
                  variant="success"
                  size="sm"
                  >In Tem</b-button
                >
                <b-button
                  @click="doDestroyTem(row.item)"
                  variant="danger"
                  size="sm"
                  >Hủy Tem</b-button
                >
                <b-button
                  @click="doRemoveTem(row.item)"
                  variant="danger"
                  size="sm"
                  >Xóa Tem</b-button
                >

              </template>
              <template v-else>
                <b-badge variant="danger">
                  <strike>
                    Tem đã hủy
                  </strike>
                </b-badge>
              </template>
            </template>
            <template>
              <pagination
                class="mt-2 mb-2 mr-2"
                slot="footer"
                :total="listQuery.total"
                :perPage="listQuery.limit"
                @change="pagChange"
              />
            </template>
          </soft-table>
        </div>
      </div>
    </block>
    <PreviewTem ref="preview"></PreviewTem>
    <CancelTemModal ref="destroy"></CancelTemModal>
    <AddTemModal @submit:success="fetchData" ref="addItem"></AddTemModal>
  </div>
</template>
<script>
import TemBichPreview from "./__TemBichPreview";
import TemBao from "./__TemBao";
import TemBaoPreview from "./__TemBaoPreview";
import TemBaoCS from "./__TemBaoCS";;
import TemDH from "./__TemDH";

import PreviewTem from "./__PreviewTem";
import CancelTemModal from "./__CancelTemModal";
import AddTemModal from "./__AddTemModal";

import { temService } from "@/_services";
export default {
  name: "tem-manage",
  components: {
    TemBichPreview,
    TemBaoPreview,
    TemDH,
    PreviewTem,
    CancelTemModal,
    AddTemModal
  },
  data() {
    return {
      manufacture: {},
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        temId: ""
      },
      countChecked: 0,
      lastIndexSelected: 0,
      Tem: {
        sl: 0,
        dm: 0,
        slc: 0,
        slb: 0,
        tlb: 0,
        tlc: 0,
        slo: 0, // Số lượng lẽ
        manufatureCode: "",
        quantity: 0,
        quantityBag: 1,
        quantityCore: 1,
        manufature: {}
      },
      temDetails: [],
      temDetailSelects: [],
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "col-fix checkbox"
        },
        {
          key: "type",
          label: "Loại Tem",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "code",
          label: "Mã tem",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "review",
          label: "Xem thử",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "countPrint",
          label: "Số lần in",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "lastDatePrint",
          label: "Lần cuối in",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "note",
          label: "Ghi chú",
          sortable: true
        },
        {
          key: "status",
          label: "Trạng thái",
          sortable: true,
          class: "col-fix text-center"
        },
        {
          key: "print",
          label: "In",
          sortable: true,
          class: "col-fix text-center"
        }
      ],
      info: {},
      type: "bich"
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.$route.query.tem) {
        this.$refs.btem.block();
        this.listQuery.temId = this.$route.query.tem;
        temService.findTemDetail(this.listQuery).then(res => {
          this.$refs.btem.unBlock();
          if (res.data && res.data.id) {
            this.Tem = res.data;
            this.manufacture = this.Tem.manufature;
            this.temDetails = this.Tem.temDetail;
            // this.calcSL();
          }
        });
      }
    },
    calcSL() {
      this.Tem.manufature = {
        id: this.manufacture.id
      };

      this.Tem.slc = this.manufacture.productSpecify.metHank;
      this.Tem.slb = this.manufacture.productSpecify.hankBag;
      this.Tem.sl = this.Tem.slc * this.Tem.slb;
      this.Tem.dm = Number(this.manufacture.quotaM);
      this.Tem.tlb = this.Tem.sl * this.Tem.dm;
      this.Tem.tlc = this.Tem.slc * this.Tem.dm;
      this.Tem.quantity = Math.floor(
        this.manufacture.quantityOrder / this.Tem.sl
      );
      this.Tem.slo =
        this.manufacture.quantityOrder - this.Tem.sl * this.Tem.quantity;
    },
    doSave() {
      this.$refs.bTem.block();
      let Tem = Object.assign({}, this.Tem);
      temService
        .create(Tem)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.Tem = res.data;
        })
        .finally(() => {
          this.$refs.bTem.unBlock();
        });
    },
    doBack() {
      this.$router.go(-1);
    },
    handlePrint() {
      this.doPrintTem(this.temDetailSelects);
    },
    handlePrintAll() {
      this.doPrintTem(this.temDetails);
    },
    doPrintTem(listItem) {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(
        this.manufacture,
        this.Tem,
        this.type,
        listItem
      );
    },
    doDestroyTem(tem) {
      this.$refs.destroy.visible = true;
      this.$refs.destroy.setData(tem);
    },
    doRemoveTem (tem) {
      var self = this;
      this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.$refs.btem.block();
            self.isPending = true;
            temService
                .remove(tem.id)
              .then(res => {
                self.fetchData();
                  self.$alertify.success(res.message, {
                    duration: 4000
                  });
                })
                .finally(() => {
                  self.visible = false;
                  self.$refs.btem.unBlock();
                });
          }
        });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
    },
    handleUpdate() {},
    handleCreate() {
      this.$refs.addItem.visible = true;
      this.$refs.addItem.setData(this.Tem);
    },
    handleCopy() {
      this.$router.push({
        name: "add-order",
        query: {
          copy_id: this.info.id
        }
      });
    },
    handleAddPayment(item) {
      this.$refs.addPayment.visible = true;
      this.$refs.addPayment.setData(item);
    },
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      let listRemove = [];
      this.tableDataSelecteds.forEach(element => {
        listRemove.push(element.id);
      });
      this.$refs.bquota.block();
    },
    tbSetRowSelected(items) {
      this.temDetailSelects = items;
      this.countChecked = items.length;
    },
    doPrintTemBich() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, "bich");
    },
    doPrintTemBao() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, "bao");
    },
    doPrintTemLoi() {
      this.$refs.preview.visible = true;
      this.$refs.preview.setData(this.manufacture, this.Tem, "loi");
    }
  }
};
</script>
<style lang="scss">
#tem {
  .soft-control .table-soft tbody tr:hover {
    background: unset;
  }
}
</style>
